module.exports = __webpack_public_path__ + "static/media/emulate3d.3bfb6a69.png";